import { createContext, useContext } from 'react';
import type { OfficialHomePageProps } from './types';

/** 官网请求级地区与文案上下文；null 表示未接入官网链路，共享组件保留原有逻辑。 */
export const OfficialHomeContext = createContext<Pick<OfficialHomePageProps, 'countryCode' | 'languageCode' | 'messages'> | null>(null);

/** 读取当前请求的官网地区与文案，避免 SSR 依赖客户端全局 Store。 */
export function useOfficialHomeContext() {
  return useContext(OfficialHomeContext);
}
